import React, { lazy } from "react";

const LazyTransactions = lazy(() => import("./Transactions"));

const Transactions = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode }
) => <LazyTransactions {...props} />;

export default Transactions;
